<template>
    <footer>
        <b-container>
            <b-row>
                <b-col md="3">
                    <h3>Menu</h3>
                    <b-nav vertical class="w-100">
                        <b-nav-item :href="'https://' + website_url + '/why-gm-voices/'">Why GM Voices?</b-nav-item>
                        <b-nav-item :href="'https://' + website_url + '/about/'">About</b-nav-item>
                        <b-nav-item :href="'https://' + website_url + '/solutions/'">Solutions</b-nav-item>
                        <b-nav-item :href="'https://' + website_url + '/media/'">Media</b-nav-item>
                        <b-nav-item :href="'https://' + website_url + '/contact/'">Contact</b-nav-item>
                    </b-nav>
                </b-col>
                <b-col md="3">
                    <h3>Contact</h3>
                    <p>
                        +1 770.752.4500<br />
                        <a href="mailto:gmvinfo@gmvoices.com">GMVInfo@gmvoices.com</a>
                    </p>
                </b-col>
                <b-col md="3">
                    <h3>Social</h3>
                    <b-nav vertical class="w-100">
                        <b-nav-item href="https://www.facebook.com/gmvoices/">
                            <span class="icon-circle"><font-awesome-icon :icon="['fab', 'facebook-f']" /></span> Facebook
                        </b-nav-item>
                        <b-nav-item href="https://twitter.com/gmvoices">
                            <span class="icon-circle"><font-awesome-icon :icon="['fab', 'twitter']" /></span> Twitter
                        </b-nav-item>
                        <b-nav-item href="https://www.youtube.com/user/GMVoices1">
                            <span class="icon-circle"><font-awesome-icon :icon="['fab', 'youtube']" /></span> YouTube
                        </b-nav-item>
                        <b-nav-item href="https://www.linkedin.com/company/gm-voices">
                            <span class="icon-circle"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></span> LinkedIn
                        </b-nav-item>
                    </b-nav>
                </b-col>
                <b-col md="3">
                    <a href="/">
                        <img src="/images/logo-grey.png" />
                    </a>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div id="copyright" class="text-center">
                        <p>&copy; 2019 GM Voices, Inc.</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </footer>
</template>
<script>
    export default {
        data() {
            return {
                authenticated: false,
                dropdown: null,
                website_url: process.env.WEBSITE_URL
            };
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/Footer.vue